<template>
  <div class="drawer-container">
    <div class="setting-drawer-content">
      <div class="setting-drawer-title">
        <h1 class="drawer-title">主题风格设置</h1>
      </div>

      <div class="setting-drawer-block-checbox">
        <!-- 暗色主题 -->
        <div class="setting-drawer-block-checbox-item" @click="handleTheme('theme-dark')">
          <img src="@/assets/images/dark.svg" alt="dark" />
          <div v-if="sideTheme === 'theme-dark'" class="setting-drawer-block-checbox-selectIcon" style="display: block;">
            <i aria-label="图标: check" class="anticon anticon-check">
              <svg viewBox="64 64 896 896" data-icon="check" width="1em" height="1em" :fill="theme" aria-hidden="true" focusable="false" class="">
                 <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"/>
              </svg>
            </i>
          </div>
        </div>
        <!-- 亮色主题 -->
        <div class="setting-drawer-block-checbox-item" @click="handleTheme('theme-light')">
          <img src="@/assets/images/light.svg" alt="light" />
          <div v-if="sideTheme === 'theme-light'" class="setting-drawer-block-checbox-selectIcon" style="display: block;">
            <i aria-label="图标: check" class="anticon anticon-check">
              <svg viewBox="64 64 896 896" data-icon="check" width="1em" height="1em" :fill="theme" aria-hidden="true" focusable="false" class="">
                <path d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"/>
              </svg>
            </i>
          </div>
        </div>
      </div>

      <div class="drawer-item">
        <span>主题颜色</span>
        <theme-picker style="float: right; height: 26px;" @change="themeChange" />
      </div>

      <div class="drawer-item">
        <span>标签页主题</span>
        <el-switch
          v-model="tagsViewTheme"
          class="drawer-switch"
          active-color="#409EFF"
          :active-value="'#409EFF'"
          inactive-color="#42b983"
          :inactive-value="'#42b983'" />
        <!-- <el-radio-group v-model="tagsViewTheme">
          <el-radio :label="'#'">若依</el-radio>
          <el-radio :label="'#'">element-admin</el-radio>
        </el-radio-group> -->
      </div>
    </div>

    <el-divider></el-divider>

    <div class="setting-drawer-title">
      <h1 class="drawer-title">系统布局配置</h1>
    </div>
      <div class="drawer-item">
        <span>开启标签页</span>
        <el-switch v-model="tagsView" class="drawer-switch" />
      </div>

      <div class="drawer-item">
        <span>固定导航栏</span>
        <el-switch v-model="fixedHeader" class="drawer-switch" />
      </div>

      <div class="drawer-item">
        <span>显示 Logo</span>
        <el-switch v-model="sidebarLogo" class="drawer-switch" />
      </div>

    <el-divider/>

    <el-row style="text-align: center;">
      <el-col :span="12">
        <el-button size="small" type="primary" plain icon="el-icon-document-add" @click="saveSetting">保存配置</el-button>
      </el-col>
      <el-col :span="12">
        <el-button size="small" plain icon="el-icon-refresh" @click="resetSetting">重置配置</el-button>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import ThemePicker from '../../components/ThemePicker/index'

export default {
  name: 'Setting',

  components: { ThemePicker },

  computed: {
    // 是否开启标签页
    tagsView: {
      get () {
        return this.$store.getters.tagsView
      },
      set (val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'tagsView',
          value: val
        })
      }
    },
    // 是否显示Logo
    sidebarLogo: {
      get () {
        return this.$store.getters.sidebarLogo
      },
      set (val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'sidebarLogo',
          value: val
        })
      }
    },
    // 固定顶部导航栏
    fixedHeader: {
      get () {
        return this.$store.getters.fixedHeader
      },
      set (val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'fixedHeader',
          value: val
        })
      }
    },
    // 标签页背景色
    tagsViewTheme: {
      get () {
        return this.$store.getters.tagsViewTheme
      },
      set (val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'tagsViewTheme',
          value: val
        })
      }
    }
  },

  data () {
    return {
      // 侧边栏主题
      sideTheme: this.$store.getters.sideTheme,
      // 系统主题色
      theme: this.$store.state.settings.theme
    }
  },

  mounted () {},

  methods: {
    // 切换侧边栏主题
    handleTheme (val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'sideTheme',
        value: val
      })
      this.sideTheme = val
    },
    // 修改标签页主题
    themeChange (val) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'theme',
        value: val
      })
      this.theme = val
    },
    // 保存配置
    saveSetting () {
      // 加载等待框
      const loading = this.$loading({
        lock: true,
        text: '正在保存当前配置...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 将内容存储到本地
      window.localStorage.setItem(
        'layout-setting',
        `{
            "tagsView":${this.tagsView},
            "fixedHeader":${this.fixedHeader},
            "sidebarLogo":${this.sidebarLogo},
            "sideTheme":"${this.sideTheme}",
            "tagsViewTheme": "${this.tagsViewTheme}"
          }`
      )
      setTimeout(() => {
        loading.close()
      }, 1000)
    },
    // 重置系统设置
    resetSetting () {
      const loading = this.$loading({
        lock: true,
        text: '正在保存当前配置并刷新...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      window.localStorage.removeItem('layout-setting')
      setTimeout(() => {
        loading.close()
        // 刷新当前页面
        window.location.reload()
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-drawer-content {
  .setting-drawer-title {
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 22px;
    font-weight: bold;
  }

  .setting-drawer-block-checbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 20px;

    .setting-drawer-block-checbox-item {
      position: relative;
      margin-right: 16px;
      border-radius: 2px;
      cursor: pointer;

      img {
        width: 48px;
        height: 48px;
      }

      .setting-drawer-block-checbox-selectIcon {
        position: absolute;
        top: 0;
        right: 0;
        left: 22px;
        width: 100%;
        height: 100%;
        padding-top: 15px;
        color: #1890ff;
        font-weight: 700;
        font-size: 14px;
      }
    }
  }
}

.drawer-container {
  padding: 20px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;

  .drawer-title {
    margin-bottom: 12px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 22px;
  }

  .drawer-item {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    padding: 12px 0;
  }

  .drawer-switch {
    float: right;
  }
}
</style>
